import { css } from "styled-components";

import { cardApearAnim, cardChangeAnim } from "./TransitionsKeyframes";

export const cardApearAnimation = css`
  animation: ${cardApearAnim} 0.5s forwards;
`;
export const cardChangeAnimation = css`
  animation: ${cardChangeAnim} 0.5s forwards;
`;
